const _throttle = require('lodash.throttle'); // eslint-disable-line no-underscore-dangle
const utils = require('./utils.js');
const generalReDuck = require('./appState/ducks/general');

window.DR = window.DR || {};

function globalResizeHandler() {
  let viewportWidth = utils.viewport().width;

  window.addEventListener('resize', _throttle(() => {
    if (utils.viewport().width === viewportWidth) { return; }
    const dims = utils.viewport();
    viewportWidth = dims.width;
    window.DR.pubsub.emit('resize', dims);
    window.appState.dispatch(generalReDuck.updateViewportWidth());
    window.appState.dispatch(generalReDuck.updateDeviceType());
  }, 100, { leading: false }));

  // Global scroll handler
  window.addEventListener('scroll', _throttle(() => {
    const dims = utils.viewport();
    window.DR.pubsub.emit('scroll', dims);
  }, 100, { leading: false }));
}

module.exports = globalResizeHandler;
